import { Component } from '@angular/core';
import { BaseKnowledgeCatalogService } from './services/base-knowledge-catalog.service';
import { I18nService } from 'i18n/i18n.service';
import { IKBCatalogCategory, IKBCatalogCategoryLearned } from './interfaces/IBase-knowledge-catalog';
import { BzgToastService, BzgToastType } from 'bz-genome-angular';
import { ShowToastService } from 'app/shared/services/showToast.service';

@Component({
  selector: 'biz-base-knowledge-catalog',
  templateUrl: './base-knowledge-catalog.component.html',
  styleUrls: ['./base-knowledge-catalog.component.scss']
})

export class BaseKnowledgeCatalogComponent {
  selectedTab: number = 0;
  showLoading: boolean = true;
  showLearned: boolean = false;
  showFiles: boolean = false;
  catalogCreationEnabled: boolean = false;
  isChangingCategory: boolean = false;
  inputSearch = '';

  categoryList: IKBCatalogCategory[] = [];
  selectedCategory: IKBCatalogCategory;
  allCategory: IKBCatalogCategory = { DisplayName: 'All', Description: 'All', Id: 'All', Expanded: false, EditMode: false, KBCatalogs: [] };
  filteredCategoryList: IKBCatalogCategory[] = [];

  categoryListLearned: IKBCatalogCategoryLearned[] = [];
  filteredCategoryListLearned: IKBCatalogCategoryLearned[] = [];

  constructor(private _baseKnowledgeCatalogService: BaseKnowledgeCatalogService,
    private _i18nService: I18nService,
    private _toastService: BzgToastService,
    private _showToastService: ShowToastService
  ) { }

  ngOnInit(): void {
    this.showLoading = true;
    this.checkBaseKnowledgeFeaturesEnabled();
    this.getBaseKnowledgeCatalog();
    this.getBaseKnowledgeCatalogLearned();
  }

  getTabIndex(tabType): number {
    let index = 0;
    if (tabType === 'files') {
      return this.showFiles ? index : -1;
    } else if (tabType === 'learned') {
      if (this.showFiles) 
        index++;
      return this.showLearned ? index : -1;
    }
    
    return -1;
  }

  getBaseKnowledgeCatalog() {
    
    this._baseKnowledgeCatalogService.getBaseKnowledgeCatalog().subscribe((res) => {
      if (res.length > 0) {
        this.categoryList = res;
        this.setArtifactStatusLocalized();
        this.selectedCategory = this.allCategory;
        this.filteredCategoryList = this.categoryList;
        this.collapsedList();
      }
      if (this.showLoading) {
        this.showLoading = false;
      }
    });
  }

  getBaseKnowledgeCatalogLearned() {
    this._baseKnowledgeCatalogService.getBaseKnowledgeCatalogLearned().subscribe((res) => {
      if (res.length > 0) {
        this.categoryListLearned = res;
        this.filteredCategoryListLearned = this.categoryListLearned;
        this.setArtifactStatusLocalizedLearned();
        this.collapsedList();
      }
      if (this.showLoading) {
        this.showLoading = false;
      }
    });
  }

  setArtifactStatusLocalized(): void {
    this.categoryList.forEach(category => {
      category.KBCatalogs.forEach(catalog => {
        catalog.KBArtifacts.forEach(artifact => {
          artifact.ArtifactStatus = artifact.ArtifactStatus.toUpperCase();
          artifact.ArtifactStatusLocalized = this._i18nService.instant('BASEKNOWLEDGECATALOG.ARTIFACT_STATUS.' + artifact.ArtifactStatus.toLocaleUpperCase());
        });
      });
    });
  }

  setArtifactStatusLocalizedLearned(): void {
    this.categoryListLearned.forEach(category => {
      category.KBLearned.forEach(kbLearned => {
          kbLearned.Status = kbLearned.Status.toUpperCase();
          kbLearned.StatusLocalized = this._i18nService.instant('BASEKNOWLEDGECATALOG.STATUS.' + kbLearned.Status.toLocaleUpperCase());
        });
    });
  }

  checkBaseKnowledgeFeaturesEnabled() {
    this._baseKnowledgeCatalogService.checkBaseKnowledgeFeaturesEnabled().subscribe((res) => {
      this.showLearned = res.EnableLearnedKnowledge;
      this.showFiles = res.EnableFilesKnowledge;
    });
  }

  onEnterSearch(): void {
    this.onSearch(this.inputSearch);
  }

  onSearch(searchString: string): void {
    if (this.isChangingCategory) return;
    
    this.inputSearch = searchString;
    const lowerCaseSearchString = searchString.toLowerCase();
    this.selectedCategory = this.allCategory;

    if (lowerCaseSearchString === '') {
      this.filteredCategoryList = this.categoryList;
      this.filteredCategoryListLearned = this.categoryListLearned;
      this.collapsedList();
      return;
    } else {
      // Tab 0 - Búsqueda en archivos (file)
      if (this.selectedTab === 0) {
        this.searchInFiles(lowerCaseSearchString);
      }
      // Tab 1 - Búsqueda en datos de Bizagi (bizagidata)
      else if (this.selectedTab === 1) {
        this.searchInBizagiData(lowerCaseSearchString);
      }
    }
  }

  onCategoryChange(event: IKBCatalogCategory): void {
    this.isChangingCategory = true; 
    this.inputSearch = '';
    
    if (event.Id === 'All') {
      this.filteredCategoryList = this.categoryList;
      this.filteredCategoryListLearned = this.categoryListLearned;
      this.collapsedList();
    } else {
      this.filteredCategoryList = this.categoryList.filter(category => category.Id === event.Id);
      this.filteredCategoryListLearned = this.categoryListLearned.filter(category => category.Id === event.Id);
      this.collapsedList();
    }
    
    setTimeout(() => {
      this.isChangingCategory = false;
    }, 0);
  }

  collapsedList(): void {
    this.filteredCategoryList.forEach((category, categoryIndex) => {
      if (categoryIndex === 0) {
        category.Expanded = true;
        category.KBCatalogs.forEach((catalog, catalogIndex) => {
          catalog.Expanded = catalogIndex === 0;
        });
      } else {
        category.Expanded = false;
        category.KBCatalogs.forEach(catalog => {
          catalog.Expanded = false;
        });
      }
    });
    this.filteredCategoryListLearned.forEach((category, categoryIndex) => {
      if (categoryIndex === 0) {
        category.Expanded = true;
        category.KBLearned.forEach((KBLearned, KBLearnedIndex) => {
          KBLearned.Expanded = KBLearnedIndex === 0;
        });
      } else {
        category.Expanded = false;
        category.KBLearned.forEach(KBLearned => {
          KBLearned.Expanded = false;
        });
      }
    });
  }

  refreshKBLearned(kbLearnedId: Guid): void {
    this._baseKnowledgeCatalogService.retryLearnedVectorization(kbLearnedId).subscribe((res) => {
      if (res) {
        // Find and update the status of the specific KBLearned
        this.categoryListLearned.forEach(category => {
          const kbLearned = category.KBLearned.find(kb => kb.Id === kbLearnedId);
          if (kbLearned) {
            // Update the status with the service response
            kbLearned.Status = res;
            kbLearned.Status = kbLearned.Status.toUpperCase();
            kbLearned.StatusLocalized = this._i18nService.instant('BASEKNOWLEDGECATALOG.STATUS.' + kbLearned.Status.toLocaleUpperCase());
          }
        });
        
        // Also update in the filtered list if it exists
        this.filteredCategoryListLearned.forEach(category => {
          const kbLearned = category.KBLearned.find(kb => kb.Id === kbLearnedId);
          if (kbLearned) {
            kbLearned.Status = res;
            kbLearned.Status = kbLearned.Status.toUpperCase();
            kbLearned.StatusLocalized = this._i18nService.instant('BASEKNOWLEDGECATALOG.STATUS.' + kbLearned.Status.toLocaleUpperCase());
          }
        });
        
        this._showToastService.showToast(this._i18nService.instant('BASEKNOWLEDGECATALOG.DATA_RETRY'), 'success');
      }
    });
  }

  reloadCatalogs(event: boolean): void {
    if (event)
      this.getBaseKnowledgeCatalog();
  }

  selectTab(index: number): void {
    this.selectedTab = index;
  }

  private searchInFiles(lowerCaseSearchString: string): void {
    let searchResultCategories = this.categoryList.filter(category => {
      const matchingCatalogs = category.KBCatalogs.filter(catalog => {
        const matchingArtifacts = catalog.KBArtifacts.filter(artifact =>
          artifact.DisplayName.toLowerCase().includes(lowerCaseSearchString)
        );
        catalog.Expanded = matchingArtifacts.length > 0 || catalog.DisplayName.toLowerCase().includes(lowerCaseSearchString);
        return catalog.Expanded;
      });
      category.Expanded = matchingCatalogs.length > 0 || category.DisplayName.toLowerCase().includes(lowerCaseSearchString);
      return category.Expanded;
    });

    this.filteredCategoryList = searchResultCategories;

    let searchResultCategoriesLearned = this.categoryListLearned.filter(category => {
      const matchingKBLearned = category.KBLearned.filter(kblearned => {
        kblearned.Expanded = kblearned.DisplayName.toLowerCase().includes(lowerCaseSearchString);
        return kblearned.Expanded;
      });
      category.Expanded = matchingKBLearned.length > 0 || category.DisplayName.toLowerCase().includes(lowerCaseSearchString);
      return category.Expanded;
    });
    this.filteredCategoryListLearned = searchResultCategoriesLearned;
  }

  private searchInBizagiData(lowerCaseSearchString: string): void {
    let searchResultCategories = this.categoryList.map(category => {
      const matchingCatalogs = category.KBCatalogs.map(catalog => {
        const matchingArtifacts = catalog.KBArtifacts.filter(artifact =>
          artifact.DisplayName.toLowerCase().includes(lowerCaseSearchString)
        );
        
        // Only include the catalog if it has matching artifacts or if the catalog name matches
        if (matchingArtifacts.length > 0 || catalog.DisplayName.toLowerCase().includes(lowerCaseSearchString)) {
          return {
            ...catalog,
            KBArtifacts: catalog.DisplayName.toLowerCase().includes(lowerCaseSearchString) ? catalog.KBArtifacts : matchingArtifacts,
            Expanded: true
          };
        }
        return null;
      }).filter(catalog => catalog !== null);

      // Only include the category if it has matching catalogs or if the category name matches
      if (matchingCatalogs.length > 0 || category.DisplayName.toLowerCase().includes(lowerCaseSearchString)) {
        return {
          ...category,
          KBCatalogs: category.DisplayName.toLowerCase().includes(lowerCaseSearchString) ? category.KBCatalogs : matchingCatalogs,
          Expanded: true
        };
      }
      return null;
    }).filter(category => category !== null);

    this.filteredCategoryList = searchResultCategories;

    let searchResultCategoriesLearned = this.categoryListLearned.map(category => {
      const matchingKBLearned = category.KBLearned.filter(kblearned =>
        kblearned.DisplayName.toLowerCase().includes(lowerCaseSearchString)
      );

      // Only include the category if it has matching KBLearned elements or if the category name matches
      if (matchingKBLearned.length > 0 || category.DisplayName.toLowerCase().includes(lowerCaseSearchString)) {
        const filteredKBLearned = category.DisplayName.toLowerCase().includes(lowerCaseSearchString) 
          ? category.KBLearned 
          : matchingKBLearned;
        
        return {
          ...category,
          KBLearned: filteredKBLearned.map(kblearned => ({
            ...kblearned,
            Expanded: kblearned.DisplayName.toLowerCase().includes(lowerCaseSearchString)
          })),
          Expanded: true
        };
      }
      return null;
    }).filter(category => category !== null);

    this.filteredCategoryListLearned = searchResultCategoriesLearned;
  }
  
  get isDevelopment(): boolean {
    const environmentType = sessionStorage.getItem('environmentType');
    return environmentType?.toLowerCase() === 'development';
  } 
}
